import { Stack, Typography } from '@mui/material';
import { FC } from 'react';
import { formatPrice } from '@vy/services';
import { DEFAULT_CURRENCY } from '@vy/types';
import { VyDivider } from '../../../../../components/new-design/atoms';
import { colors } from '../../../../../assets/themes/colors';
import { getSelectorAttribute } from '@vy/app-selectors';

export type MMRBreakdownRow = { label: string; value: number; dataVy: string };

type MMRBreakdownProps = {
  data: MMRBreakdownRow[];
  endingMrr: number;
  endingMrrDataVy: string;
};

export const MMRBreakdown: FC<MMRBreakdownProps> = ({ data, endingMrr, endingMrrDataVy }) => {
  return (
    <Stack
      sx={{
        padding: "10px 16px",
        borderRadius: 2,
        gap: 1,
        background: colors.grey[10]
      }}>
      {data.map(({ label, value, dataVy }) => (
        <Stack
          key={label}
          direction="row"
          {...getSelectorAttribute(dataVy)}
          sx={{
            justifyContent: "space-between",
            alignItems: "center"
          }}>
          <Typography variant="body2" color="textSecondary">
            {label}
          </Typography>
          <Typography variant="body2" color="textPrimary">
            {formatPrice(value, DEFAULT_CURRENCY)}
          </Typography>
        </Stack>
      ))}
      <VyDivider />
      <Stack
        direction="row"
        {...getSelectorAttribute(endingMrrDataVy)}
        sx={{
          justifyContent: "space-between",
          alignItems: "center"
        }}>
        <Typography variant="body1" sx={{
          fontWeight: "600"
        }}>
          Ending MRR
        </Typography>
        <Typography variant="body1" sx={{
          fontWeight: "600"
        }}>
          {formatPrice(endingMrr, DEFAULT_CURRENCY)}
        </Typography>
      </Stack>
    </Stack>
  );
};
